import {Button} from 'antd';
import {ColumnsType} from 'antd/es/table';
import moment from 'moment';
import React from 'react';
import {Link} from 'react-router-dom';

import {AIS_ROUTES} from 'components/ais/ais.constants';
import {ReactComponent as ArrowRightOutlined} from 'shared/assets/arrow-right-outlined.svg';
import {DATE_DMY} from 'shared/constants/date-format';
import {IAisCommentsRequestResultTableDto, IAisRequestRowCommentTableDto} from 'store/slices/ais-slice/ais-comments-request';

export const COMMENTS_REQUEST_DEFAULT_PAGE_SIZE = 10;
export const COMMENTS_REQUEST_MONITOR_SERVICE_LOOKUP_CODE = 'responseFactorAnalysisComments-v3-EXTERNAL';

export enum ECommentRequestStatuses {
    NEW = 'Новый',
    COMPLETED = 'Завершен',
}

export const formRowCommentsTableHeader = (
    startYear?: number,
    endYear?: number,
    period?: string,
): ColumnsType<IAisRequestRowCommentTableDto> => [
    {
        title: 'Наименование показателя',
        dataIndex: 'factorName',
        key: 'factorName',
    },
    {
        title: 'Значение показателя по данным декларации',
        children: [
            {
                title: startYear ? `${period || ''} ${startYear}` : 'Период не определен',
                dataIndex: 'comparedValue',
                key: 'comparedValue',
                align: 'center',
                render: v => v.toLocaleString('ru-RU'),
            },
            {
                title: endYear ? `${period || ''} ${endYear}` : 'Период не определен',
                dataIndex: 'currentValue',
                key: 'currentValue',
                align: 'center',
                render: v => v.toLocaleString('ru-RU'),
            },
        ],
    },
    {
        title: 'Изменение в отчетном периоде по сравнению с предыдущим',
        children: [
            {
                title: 'абс.',
                dataIndex: 'absChange',
                key: 'absChange',
                align: 'center',
                render: v => v.toLocaleString('ru-RU'),
            },
            {
                title: 'отн.',
                dataIndex: 'relativeChange',
                key: 'relativeChange',
                align: 'center',
            },
        ],
    },
    {
        title: 'Требуется комментарий',
        dataIndex: 'commentRequired',
        key: 'commentRequired',
        align: 'center',
        render: v => (v ? 'Да' : 'Нет'),
    },
];

export const formCommentsRequestTableHeader = (
    paginationCurrent: number,
    paginationPageSize: number,
): ColumnsType<IAisCommentsRequestResultTableDto> => [
    {
        title: '№',
        dataIndex: 'key',
        render: (_, __, index) => (
            <div>
                {((paginationCurrent - 1) * paginationPageSize) + index + 1}
            </div>
        ),
    },
    {
        title: 'Карточка запроса',
        dataIndex: 'ais3AnswerFormationCard',
        key: 'ais3AnswerFormationCard',
        render: (_, row) => (
            <Link
                to={`/${AIS_ROUTES.COMMENTS_REQUEST_RESULT}/comments-request/${row.id}`}
            >
                <Button
                    className="button-redirect__table-action"
                    icon={<ArrowRightOutlined />}

                >
                    Перейти
                </Button>
            </Link>
        ),
    },
    {
        title: 'Номер запроса',
        dataIndex: 'numberRequest',
        key: 'numberRequest',
    },
    {
        title: 'Год',
        dataIndex: 'year',
        key: 'year',
        align: 'center',
    },
    {
        title: 'Период',
        dataIndex: 'period',
        key: 'period',
        width: 200,
        align: 'center',
    },
    {
        title: 'Год для сравнения',
        dataIndex: 'yearToCompare',
        key: 'yearToCompare',
        align: 'center',
    },
    {
        title: 'Дата получения запроса',
        dataIndex: 'receivingDate',
        key: 'receivingDate',
        align: 'center',
        render: date => date && moment(date).format(DATE_DMY),
    },
    {
        title: 'Плановая дата отправки ответа',
        dataIndex: 'planedSendDate',
        key: 'planedSendDate',
        align: 'center',
        render: date => date && moment(date).format(DATE_DMY),
    },
    {
        title: 'Фактическая дата отправки ответа',
        dataIndex: 'sendDate',
        key: 'sendDate',
        align: 'center',
        render: date => date && moment(date).format(DATE_DMY),
    },
];
